import "./Navbar.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import { NavLink, useNavigate } from "react-router-dom";
import { serverAddr } from "../../networkConfig";

export default function Navbar() {
  const isLoggedIn = !!localStorage.getItem("token");
  const navigate = useNavigate();

  const handleLogout = async () => {
    closeNavbar();
    try {
      const refreshToken = localStorage.getItem("refresh_token");
      await serverAddr.post("auth/logout/", { refresh: refreshToken });
    } catch (_) {
      // proceed with logout even if API fails
    }
    localStorage.clear();
    navigate("/login", { replace: true });
  };

  const closeNavbar = () => {
    const nav = document.getElementById("navMenu");
    if (nav && nav.classList.contains("show")) {
      nav.classList.remove("show");
    }
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark custom-nav">
      <div className="container">

        {/* Logo */}
        <NavLink className="navbar-brand d-flex align-items-center" to="/" onClick={closeNavbar}>
          <img
            src={require("../../assets/Logos/Cryptoants.png")}
            alt="Logo"
            className="logo-img"
          />
        </NavLink>

        {/* Mobile Toggle */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navMenu"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Menu */}
        <div className="collapse navbar-collapse" id="navMenu">
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0">

            {/* POST-LOGIN ONLY */}
            {isLoggedIn && (
              <>
                <li className="nav-item">
                  <NavLink
                    to="/MyView"
                    onClick={closeNavbar}
                    className={({ isActive }) =>
                      isActive ? "nav-link active" : "nav-link"
                    }
                  >
                    My View
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink
                    to="/expertview"
                    onClick={closeNavbar}
                    className={({ isActive }) =>
                      isActive ? "nav-link active" : "nav-link"
                    }
                  >
                    Expert View
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink
                    to="/publisher"
                    onClick={closeNavbar}
                    className={({ isActive }) =>
                      isActive ? "nav-link active" : "nav-link"
                    }
                  >
                    Publisher
                  </NavLink>
                </li>
              </>
            )}

          </ul>

          {/* Right Side */}
          <div className="nav-right">

            <div className="contact-text">
              <span>📞 Contact us : </span>
              <a href="tel:9321765323" className="contact-number">
                9321765323
              </a>
            </div>

            {/* PRE-LOGIN: show Login link */}
            {isLoggedIn ? (
              <div className="dropdown">
                <button
                  className="avatar-circle dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="8" r="4" />
                    <path d="M4 20c0-4 3.582-7 8-7s8 3 8 7" />
                  </svg>
                </button>
                <ul className="dropdown-menu dropdown-menu-end dropdown-menu-dark">
                  <li>
                    <button className="dropdown-item">
                      Profile
                    </button>
                  </li>
                  <li>
                    <button className="dropdown-item" onClick={handleLogout}>
                      Logout
                    </button>
                  </li>
                </ul>
              </div>
            ) : (
              <li className="nav-item">
                <NavLink to="/login" className="nav-link">
                  Login
                </NavLink>
              </li>
            )}

          </div>
        </div>

      </div>
    </nav>
  );
}